/* Kansie — video gallery lazy-load + viewport pause.
   One IntersectionObserver, no dependencies. A video's real <source> is
   only attached (and only then does the file start downloading) once its
   card nears the viewport; it plays while intersecting and pauses when it
   scrolls away. Users who prefer reduced motion still get the file loaded
   (so a real first frame shows instead of a blank box) but it is never
   autoplayed for them. */
(function () {
  if (customElements.get('kansie-video-gallery')) return;

  class KansieVideoGallery extends HTMLElement {
    connectedCallback() {
      const videos = this.querySelectorAll('video[data-src]');
      if (!videos.length) return;

      const prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      this._io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;

            if (entry.isIntersecting) {
              if (video.dataset.src) {
                const source = document.createElement('source');
                source.src = video.dataset.src;
                source.type = 'video/mp4';
                video.appendChild(source);
                video.preload = 'metadata';
                video.load();
                delete video.dataset.src;
              }
              if (!prefersReducedMotion) {
                video.play().catch(() => {
                  /* Autoplay can still be refused (data-saver mode, etc).
                     The video simply stays on its first frame — no error UI. */
                });
              }
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { rootMargin: '200px 0px', threshold: 0.25 }
      );

      videos.forEach((video) => this._io.observe(video));
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
    }
  }

  customElements.define('kansie-video-gallery', KansieVideoGallery);
})();
